/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDto } from '../../models/admin-dto';

export interface AdminControllerFindAll$Params {
}

export function adminControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdminDto>>;
    })
  );
}

adminControllerFindAll.PATH = '/api/admin';
